import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { getAccount } from '../../../Api'
import downloadPurple from '../../SearchResults/images/DownloadSVG.svg'
import useStore from '../ProductStore/Store'
import arrowLeft from '../images/arrowLeft.svg'
import arrowRight from '../images/arrowRight.svg'
import DownloadModal from '../../DownloadDr6/DownloadModal'
import styles from './styles.module.css'
import Results from './ListOfResults/Results'
import ExampleSearches from './ExampleResults/ExampleSearches'

function SearchResults () {
  const {
    data: AccountData,
    isLoading,
    refetch
  } = useQuery('account', getAccount)

  const {
    dataResults,
    queryStore,
    isQueryLoading,
    page,
    setPage,
    shouldRefetch,
    setShouldRefetch
  } = useStore()

  const [calculatedCredits, setCalculatedCredits] = useState(0)
  const queryToDownload = queryStore?.query
  const dataToDownload = dataResults?.data
  const TOTAL_NUMBER_RECORDS = dataResults?.data?.num_found
  const RECORDS_PER_PAGE = 50
  const isPreviousDisabled = page <= 1
  const totalNumberOfPages = Math.ceil(TOTAL_NUMBER_RECORDS / RECORDS_PER_PAGE)
  const isNextDisabled = page >= totalNumberOfPages
  const [startIndex, setStartIndex] = useState(1)
  const [endIndex, setEndIndex] = useState(RECORDS_PER_PAGE)
  const dataType = 'product' // Set the data type to product

  const [isDownloadModalVisible, setIsDownloadModalVisible] = useState(false)

  // Calculate credits based on product plan
  useEffect(() => {
    const processPlans = () => {
      if (!AccountData?.data?.plans) return
      AccountData.data.plans.forEach(plan => {
        if (plan.id && plan.id.includes('product')) {
          const credits =
            plan?.credits_allotted - AccountData?.data?.product_credits_used
          setCalculatedCredits(credits)
          return // exit loop once found
        }
      })
    }
    processPlans()
  }, [AccountData])

  // Refetch account data if shouldRefetch flag is set
  useEffect(() => {
    if (shouldRefetch) {
      refetch()
      setShouldRefetch(false)
    }
  }, [shouldRefetch, refetch, setShouldRefetch])

  const goToNextPage = () => {
    if (page < totalNumberOfPages) {
      setPage(page + 1)
    }
  }

  const goToPreviousPage = () => {
    if (page > 1) {
      setPage(page - 1)
    }
  }

  const toggleDownloadModal = () => {
    if (queryToDownload && !isQueryLoading) {
      setIsDownloadModalVisible(!isDownloadModalVisible)
    }
  }

  useEffect(() => {
    const newStartIndex = (page - 1) * RECORDS_PER_PAGE + 1
    const newEndIndex = Math.min(
      newStartIndex + RECORDS_PER_PAGE - 1,
      TOTAL_NUMBER_RECORDS
    )
    setStartIndex(newStartIndex)
    setEndIndex(newEndIndex)
  }, [page, RECORDS_PER_PAGE, TOTAL_NUMBER_RECORDS])

  const downloadStyle =
    isQueryLoading || !queryToDownload
      ? { cursor: 'not-allowed', opacity: 0.5 }
      : { cursor: 'pointer' }

  return (
    <div style={{ width: '1257px' }}>
      <h1 className={styles.searchResultBusinessTitle}>Search results</h1>
      <div className={styles.searchResultBusinessFlexGap}>
        <div style={{ display: 'flex', gap: '20px' }}>
          <div>
            <span className={styles.searchResultBusinessTotalMatches}>
              Total available matches:
            </span>
            <span className={styles.searchResultBusinessTotalMatchesValue}>
              {dataResults?.data?.num_found
                ? dataResults?.data?.num_found.toLocaleString('en-US')
                : 'N/A'}
            </span>
          </div>

          <div>
            <span className={styles.searchResultBusinessRecordCredits}>
              Available record credits:
            </span>
            <span className={styles.searchResultBusinessRecordCreditsValue}>
              {isLoading
                ? 'Loading...'
                : AccountData?.data?.role === 'admin'
                ? 'Admin'
                : calculatedCredits
                ? calculatedCredits
                : 'N/A'}
            </span>
          </div>

          <div>
            <span
              className={styles.searchResultBusinessDownloadLabel}
              style={downloadStyle}
              onClick={toggleDownloadModal}
            >
              Download
            </span>
            <img
              src={downloadPurple}
              alt='upload'
              style={downloadStyle}
              className={styles.searchResultBusinessDownloadIcon}
              onClick={toggleDownloadModal}
            />
          </div>
        </div>
        <div style={{ display: 'flex', alignSelf: 'end' }}>
          {dataResults?.data ? (
            <div className={styles.searchResultBusinessPaginationContainer}>
              <span className={styles.searchResultBusinessShowingRecords}>
                Showing records:
              </span>
              <span className={styles.searchResultBusinessShowingRecordsValue}>
                {startIndex} - {endIndex}
              </span>
              <img
                onClick={
                  !(isPreviousDisabled || isQueryLoading)
                    ? goToPreviousPage
                    : undefined
                }
                src={arrowLeft}
                alt='Previous'
                className={styles.searchResultBusinessArrow}
                style={{
                  opacity: isPreviousDisabled || isQueryLoading ? 0.5 : 1,
                  cursor:
                    isNextDisabled || isQueryLoading || page === 1
                      ? 'not-allowed'
                      : 'pointer'
                }}
              />
              <img
                onClick={
                  !(isNextDisabled || isQueryLoading) ? goToNextPage : undefined
                }
                src={arrowRight}
                alt='Next Page'
                className={styles.searchResultBusinessArrow}
                style={{
                  opacity: isNextDisabled || isQueryLoading ? 0.5 : 1,
                  cursor:
                    isNextDisabled || isQueryLoading ? 'not-allowed' : 'pointer'
                }}
              />
            </div>
          ) : null}
        </div>
      </div>

      {dataResults?.data ? <Results /> : <ExampleSearches />}

      {isDownloadModalVisible && (
        <DownloadModal
          onClose={toggleDownloadModal}
          totalRecords={TOTAL_NUMBER_RECORDS}
          dataToDownload={dataToDownload}
          queryToDownload={queryToDownload}
          dataType={dataType} // Pass 'product' as the data type
        />
      )}
    </div>
  )
}

export default SearchResults
